<template>
  <div class="fm-grid">
    <div v-if="loadingSpinner">
      <loading :active.sync="showLoaderModal" :can-cancel="false" loader="dots" color="rgb(20, 80, 144)" :width="75"
        :is-full-page="false">
      </loading>
    </div>
    <div v-else-if="directories.length === 0 && files.length === 0">
      <div v-if="breadcrumb !== null">
        <div class="empty-state text-center" v-if="breadcrumb[0] === 'searchResult'">
          <i class="bx bx-search-alt mb-3"></i>
          <h5 class="mb-3">
            {{ $t("filemanager.location.search_result.title") }}
          </h5>
          <p>{{ $t("filemanager.location.search_result.text") }}</p>
        </div>
        <div class="empty-state text-center" v-else>
          <transition name="fade" appear>
            <div>
              <i class="bx bxs-file mb-3"></i>
              <h5 class="mb-3">
                {{ $t("filemanager.location.empty.title") }}
              </h5>
              <p>{{ $t("filemanager.location.empty.text") }}</p>
            </div>
          </transition>
          <button class="btn btn-light" v-on:click="showModal('Upload')">
            {{ $t("navbar.buttons.upload") }}
          </button>
        </div>
      </div>
      <div class="empty-state text-center" v-else>
        <!-- {{"on passe la : " + breadcrumb}} -->
        <transition name="fade" appear>
          <div>
            <i class="bx bxs-file mb-3"></i>
            <h5 class="mb-3">
              {{ $t("filemanager.location.empty.title") }}
            </h5>
            <p>{{ $t("filemanager.location.empty.text") }}</p>
            <!-- <p class="text-muted mt-2">Glissez / deposez des fichiers ou documents ici pour les ajouter</p> -->
          </div>
        </transition>
        <button class="btn btn-light" v-on:click="showModal('Upload')">
          {{ $t("navbar.buttons.upload") }}
        </button>
      </div>
    </div>
    <div class="d-flex align-content-start flex-wrap" v-else>

      <div class="fm-grid-item-folder text-center unselectable" v-for="(directory, index) in directories"
        v-bind:key="`d-${index}`" v-bind:title="directory.basename"
        v-bind:class="{ active: checkSelect('directories', directory.path) }"
        v-on:click="selectItem('directories', directory.path, $event)" v-on:dblclick.stop="
          acl && directory.acl !== 0
            ? selectDirectory(directory.path)
            : diplayAccessMessage()
        " v-on:contextmenu.prevent.stop="
          acl && directory.acl !== 0 ? contextMenu(directory, $event) : false
        ">
        <transition name="fade" appear>
          <div class="fm-item-icon" v-if="!directory.shared">
            <!-- <i v-if="(acl && directory.acl === 0)" class="fas fa-unlock-alt fa-5x pb-2"/> -->
            <img width="80" class="fm-folder-item" v-if="acl && directory.acl === 0" src="../../assets/lock.png"
              alt="" />
            <img width="80" class="fm-folder-item" v-else-if="getItemLevel(directory.path) === 1"
              src="../../assets/folder.svg" alt="" />
            <img width="80" class="fm-folder-item" v-else-if="getItemLevel(directory.path) === 2"
              src="../../assets/folder.svg" alt="" />
            <img width="80" class="fm-folder-item" v-else src="../../assets/shared.svg" alt="" />
          </div>
          <div class="fm-item-icon" v-else>
            <!-- <i v-if="(acl && directory.acl === 0)" class="fas fa-unlock-alt fa-5x pb-2"/> -->
            <img width="80" class="fm-folder-item" v-if="acl && directory.acl === 0" src="../../assets/lock.png"
              alt="" />
            <img width="80" class="fm-folder-item" v-else-if="getItemLevel(directory.path) === 1"
              src="../../assets/shared.svg" alt="" />
            <img width="80" class="fm-folder-item" v-else-if="getItemLevel(directory.path) === 2"
              src="../../assets/shared.svg" alt="" />
            <img width="80" class="fm-folder-item" v-else src="../../assets/shared.svg" alt="" />
          </div>
        </transition>
        <transition name="fade" appear>
          <div class="fm-item-info">
            {{ directory.basename }} <br />
            <!-- {{ lang.modal.properties['access_' + directory.acl] }} -->
          </div>
        </transition>
      </div>
      <!-- <button id="tooltip-top">Tooltip</button>
      <b-tooltip target="tooltip-top">Tooltip on top</b-tooltip> -->
      <div class="fm-grid-item-file text-center unselectable"
        v-for="(file, index) in files" v-bind:key="`f-${index}`"
        v-bind:title="file.basename" v-bind:class="{ active: checkSelect('files', file.path) }"
        v-on:click="selectItem('files', file.path, $event)" v-on:dblclick="
          acl && file.acl !== 0
            ? selectAction(file.path, file.extension)
            : diplayAccessMessage()
        " v-on:contextmenu.prevent.stop="
          acl && file.acl !== 0 ? contextMenu(file, $event) : false
        ">
        <transition name="fade" appear>
          <div class="fm-item-icon">
            <!-- <i v-if="acl && file.acl === 0" class="fas fa-unlock-alt fa-5x pb-2"/> -->
            <!-- <img v-if="acl && file.acl === 0" src="../../assets/padlock.png" alt="" /> -->
            <thumbnail v-if="thisImage(file.extension)" v-bind:disk="disk" v-bind:file="file">
            </thumbnail>
            <!-- <pdfThumbnail v-else-if="file.extension === 'pdf'"
                v-bind:disk="disk"
                v-bind:file="file">
          </pdfThumbnail> -->
            <div v-else-if="file.extension === 'pdf'">
              <img width="60" src="../../assets/icons/pdf.png" alt="" />
            </div>
            <div v-else-if="file.extension === 'form'">
              <img width="60" src="../../assets/icons/form.png" alt="" />
            </div>
            <div v-else-if="file.extension === 'doc' || file.extension === 'docx'">
              <img width="60" src="../../assets/icons/word.svg" alt="" />
            </div>
            <div v-else-if="file.extension === 'xls' || file.extension === 'xlsx'">
              <img width="60" src="../../assets/icons/excel.svg" alt="" />
            </div>
            <div v-else-if="file.extension === 'ppt' || file.extension === 'pptx'">
              <img width="60" src="../../assets/icons/powerpoint.svg" alt="" />
            </div>
            <div v-else-if="file.extension === 'mp3' || file.extension === 'wav'">
              <img width="60" src="../../assets/icons/audio.png" alt="" />
            </div>
            <div v-else-if="file.extension === 'mpg' || file.extension === 'mp4'">
              <img width="60" src="../../assets/icons/video.png" alt="" />
            </div>
            <i v-else class="far fa-5x pb-2" v-bind:class="extensionToIcon(file.extension)" />
          </div>
        </transition>
        <transition name="fade" appear>
          <div class="fm-item-info">
            {{ `${file.filename}.${file.extension}` }}
            <br />
            <!-- <span class="fm-item-file-size">
              {{ bytesToHuman(file.size) }}
            </span> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "../../router/mixins/helper";
import managerHelper from "./mixins/manager";
import EventBus from "../eventBus";
import Thumbnail from "./Thumbnail.vue";
import Loading from "vue-loading-overlay";

export default {
  name: "grid-view",
  components: { Thumbnail, Loading },
  mixins: [helper, managerHelper],
  data() {
    return {
      disk: "",
      url: "",
      showLoaderModal: false,
      modalTitle: "",
    };
  },
  props: {
    manager: { type: String, required: true },
  },
  mounted() {
    this.disk = this.selectedDisk;
  },
  updated() {
    // console.log("breadcrumb la : ", this.breadcrumb);
    if (this.directories.length > 0 || this.files.length > 0) {
      this.isLoading = false;
    }
    if (this.loadingSpinner > 0) {
      this.showLoaderModal = true;
    }
    if (this.loadingSpinner === 0) {
      this.showLoaderModal = false;
    }
  },
  created() {},
  beforeUpdate() {
    // if disk changed
    if (this.disk !== this.selectedDisk) {
      this.disk = this.selectedDisk;
    }
  },
  computed: {
    breadcrumb() {
      return this.$store.getters[`${this.activeManager}/breadcrumb`];
    },
    activeManager() {
      return this.$store.state.activeManager;
    },
    /**
     * Image extensions list
     * @returns {*}
     */
    imageExtensions() {
      return this.$store.state.settings.imageExtensions;
    },
    /**
     * Spinner
     * @returns {number}
     */
    loadingSpinner() {
      return this.$store.state.messages.loading;
    },
  },
  watch: {
    breadcrumb() {
      // console.log("breadcrumb : ", this.breadcrumb);
    },
  },
  methods: {
    /**
     * Show modal window
     * @param modalName
     */
    showModal(modalName) {
      // show selected modal
      this.$store.commit("modal/setModalState", {
        modalName,
        show: true,
      });
    },
    diplayAccessMessage() {
      EventBus.$emit("addNotification", {
        status: "error",
        message: "Accès refusé !",
      });
    },
    handleOnDragFolder(event) {
      console.log(event);
    },
    /**
     * Check file extension (image or no)
     * @param extension
     * @returns {boolean}
     */
    thisImage(extension) {
      // extension not found
      if (!extension) return false;

      return this.imageExtensions.includes(extension.toLowerCase());
    },

    /**
     * Check the level of an item
     * @param path
     * @returns {Int}
     */
    getItemLevel(path) {
      return path.toString().split("/").length;
    },
  },
};
</script>

<style lang="scss">
.fm-grid {
  padding-top: 3px;

  .fm-grid-item-folder {
    position: relative;
    width: 110px;
    height: 110px;
    padding: 0.4rem;
    padding-top: 20px;
    margin-bottom: 1rem;
    margin-right: 1rem;
    border-radius: 12px;
    // border: 1px solid rgb(219, 230, 230);
    cursor: pointer;

    // .fm-folder-item {
    //   transition: width ease-in;
    // }

    // .fm-folder-item:hover {
    //   width: 84px;
    // }

    &.active {
      background-color: #e3f1fd;
      // border: 1px solid #cadce7;
    }

    &:not(.active):hover {
      background-color: #f1f8ff;
      // box-shadow: 3px 2px 5px gray;
      // border: 1px solid rgb(219, 230, 230);
    }

    .fm-item-icon {
      cursor: pointer;
    }

    .fm-item-icon > i,
    .fm-item-icon > figure > i {
      color: #6d757d;
    }

    .fm-item-info {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      margin-top: 4px;
      font-weight: 500;
      .fm-item-file-size {
        font-size: 12px;
        color: rgb(36, 160, 143);
      }
    }
  }

  .fm-grid-item-file {
    position: relative;
    width: 110px;
    height: 110px;
    padding: 0.4rem;
    padding-top: 20px;
    margin-bottom: 1rem;
    margin-right: 1rem;
    border-radius: 12px;
    // border: 1px solid rgb(219, 230, 230);
    cursor: pointer;

    &.active {
      background-color: #e3f1fd;
      // border: 1px solid #cadce7;
    }

    &:not(.active):hover {
      background-color: #f1f8ff;
      // box-shadow: 3px 2px 5px gray;
      // border: 1px solid rgb(219, 230, 230);
    }

    .fm-item-icon {
      cursor: pointer;
    }

    .fm-item-icon > i,
    .fm-item-icon > figure > i {
      color: #6d757d;
    }

    .fm-item-info {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      margin-top: 4px;
      font-weight: 500;
      .fm-item-file-size {
        color: rgb(36, 160, 143);
      }
    }
  }
  .empty-state {
    position: relative;
    width: 50%;
    margin: auto;
    i {
      margin-top: 14vh;
      font-size: 100px;
      color: #e8ecf1;
    }
  }
}
</style>
